import * as i0 from '@angular/core';
import { ElementRef, Component, ChangeDetectionStrategy, Inject, Input, HostBinding, NgModule } from '@angular/core';
import * as i4 from '@taiga-ui/cdk';
import { tuiTypedFromEvent, ALWAYS_TRUE_HANDLER, ALWAYS_FALSE_HANDLER, tuiIsNativeFocused, TuiFocusVisibleService, tuiAsFocusableItemAccessor, TuiDestroyService } from '@taiga-ui/cdk';
import { MODE_PROVIDER } from '@taiga-ui/core/providers';
import { TUI_MODE } from '@taiga-ui/core/tokens';
import * as i3 from 'rxjs';
import { merge } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1 from '@taiga-ui/core/components/svg';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';

// @bad TODO: Think about extending Interactive
const _c0 = ["tuiLink", ""];
const _c1 = ["*"];
function TuiLinkComponent_tui_svg_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-svg", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.icon || "");
  }
}
function TuiLinkComponent_tui_svg_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-svg", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.icon || "");
  }
}
class TuiLinkComponent {
  constructor(el, mode$, focusVisible$) {
    this.el = el;
    this.mode$ = mode$;
    this.pseudo = false;
    this.icon = '';
    this.iconAlign = 'right';
    this.iconRotated = false;
    this.mode = null;
    this.focusVisible = false;
    this.focusedChange = merge(tuiTypedFromEvent(this.el.nativeElement, 'focusin').pipe(map(ALWAYS_TRUE_HANDLER)), tuiTypedFromEvent(this.el.nativeElement, 'focusout').pipe(map(ALWAYS_FALSE_HANDLER)));
    focusVisible$.subscribe(visible => {
      this.focusVisible = visible;
    });
  }
  get nativeFocusableElement() {
    return this.el.nativeElement;
  }
  get focused() {
    return tuiIsNativeFocused(this.nativeFocusableElement);
  }
  get hasIcon() {
    return !!this.icon;
  }
  get iconAlignLeft() {
    return this.hasIcon && this.iconAlign === 'left';
  }
  get iconAlignRight() {
    return this.hasIcon && this.iconAlign === 'right';
  }
}
TuiLinkComponent.ɵfac = function TuiLinkComponent_Factory(t) {
  return new (t || TuiLinkComponent)(i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TUI_MODE), i0.ɵɵdirectiveInject(TuiFocusVisibleService));
};
TuiLinkComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: TuiLinkComponent,
  selectors: [["a", "tuiLink", ""], ["button", "tuiLink", ""]],
  hostVars: 7,
  hostBindings: function TuiLinkComponent_HostBindings(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵlistener("$.data-mode.attr", function TuiLinkComponent___data_mode_attr_HostBindingHandler() {
        return ctx.mode$;
      });
    }
    if (rf & 2) {
      i0.ɵɵattribute("data-host-mode", ctx.mode);
      i0.ɵɵclassProp("_pseudo", ctx.pseudo)("_icon-rotated", ctx.iconRotated)("_focus-visible", ctx.focusVisible);
    }
  },
  inputs: {
    pseudo: "pseudo",
    icon: "icon",
    iconAlign: "iconAlign",
    iconRotated: "iconRotated",
    mode: "mode"
  },
  exportAs: ["tuiLink"],
  features: [i0.ɵɵProvidersFeature([tuiAsFocusableItemAccessor(TuiLinkComponent), TuiFocusVisibleService, TuiDestroyService, MODE_PROVIDER])],
  attrs: _c0,
  ngContentSelectors: _c1,
  decls: 4,
  vars: 2,
  consts: [["class", "t-icon t-icon_left", 3, "src", 4, "ngIf"], [1, "t-content"], ["class", "t-icon t-icon_right", 3, "src", 4, "ngIf"], [1, "t-icon", "t-icon_left", 3, "src"], [1, "t-icon", "t-icon_right", 3, "src"]],
  template: function TuiLinkComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵtemplate(0, TuiLinkComponent_tui_svg_0_Template, 1, 1, "tui-svg", 0);
      i0.ɵɵelementStart(1, "span", 1);
      i0.ɵɵprojection(2);
      i0.ɵɵelementEnd();
      i0.ɵɵtemplate(3, TuiLinkComponent_tui_svg_3_Template, 1, 1, "tui-svg", 2);
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", ctx.iconAlignLeft);
      i0.ɵɵadvance(3);
      i0.ɵɵproperty("ngIf", ctx.iconAlignRight);
    }
  },
  dependencies: [i1.TuiSvgComponent, i2.NgIf],
  styles: ["[_nghost-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:none;font-size:inherit;line-height:inherit;text-decoration:none;transition-property:color;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;color:var(--tui-link);text-align:left;text-transform:inherit;font-weight:inherit;cursor:pointer;outline:none}[_nghost-%COMP%]:hover{color:var(--tui-link-hover)}[_nghost-%COMP%]:disabled{opacity:var(--tui-disabled-opacity);cursor:default}[data-mode=onLight][_nghost-%COMP%]{color:var(--tui-text-02)}[data-mode=onLight][_nghost-%COMP%]:hover, [data-mode=onLight]._active[_nghost-%COMP%]{color:var(--tui-text-01)}[data-mode=onLight]._pseudo[_nghost-%COMP%]{color:var(--tui-text-01)}[data-mode=onLight]._pseudo[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{-webkit-text-decoration-color:rgba(0,0,0,.48);text-decoration-color:#0000007a}[data-mode=onLight]._pseudo[_nghost-%COMP%]:hover, [data-mode=onLight]._pseudo._active[_nghost-%COMP%]{color:var(--tui-text-03)}[data-mode=onLight][data-host-mode=negative][_nghost-%COMP%]{color:var(--tui-negative-night)}[data-mode=onLight][data-host-mode=negative][_nghost-%COMP%]:hover, [data-mode=onLight][data-host-mode=negative][_nghost-%COMP%]:active, [data-mode=onLight][data-host-mode=negative]._active[_nghost-%COMP%]{color:var(--tui-negative-night-hover)}[data-mode=onDark][_nghost-%COMP%]{color:var(--tui-text-03-night)}[data-mode=onDark][_nghost-%COMP%]:hover, [data-mode=onDark][_nghost-%COMP%]:active, [data-mode=onDark]._active[_nghost-%COMP%]{color:var(--tui-text-01-night)}[data-mode=onDark]._pseudo[_nghost-%COMP%]{color:var(--tui-text-01-night)}[data-mode=onDark]._pseudo[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{-webkit-text-decoration-color:rgba(255,255,255,.48);text-decoration-color:#ffffff7a}[data-mode=onDark]._pseudo[_nghost-%COMP%]:hover, [data-mode=onDark]._pseudo[_nghost-%COMP%]:active, [data-mode=onDark]._pseudo._active[_nghost-%COMP%]{color:var(--tui-text-03-night)}[data-mode=onDark][data-host-mode=positive][_nghost-%COMP%]{color:var(--tui-positive-night)}[data-mode=onDark][data-host-mode=positive][_nghost-%COMP%]:hover, [data-mode=onDark][data-host-mode=positive][_nghost-%COMP%]:active, [data-mode=onDark][data-host-mode=positive]._active[_nghost-%COMP%]{color:var(--tui-positive-night-hover)}[data-host-mode=negative][_nghost-%COMP%]{color:var(--tui-negative)}[data-host-mode=negative][_nghost-%COMP%]:hover{color:var(--tui-negative-hover)}[data-host-mode=negative]._pseudo[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{-webkit-text-decoration-color:rgba(222,76,30,.48);text-decoration-color:#de4c1e7a}[data-host-mode=positive][_nghost-%COMP%]{color:var(--tui-positive)}[data-host-mode=positive][_nghost-%COMP%]:hover{color:var(--tui-positive-hover)}[data-host-mode=positive]._pseudo[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{-webkit-text-decoration-color:rgba(58,169,129,.48);text-decoration-color:#3aa9817a}._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-selection)}[data-mode=onLight]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-clear);color:var(--tui-text-01)}[data-mode=onDark]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-clear-inverse);color:var(--tui-text-01-night)}[data-host-mode=positive]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-success-bg)}[data-host-mode=negative]._focus-visible[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{background:var(--tui-error-bg)}._pseudo[_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding-bottom:.15em;-webkit-text-decoration:underline dashed rgba(51,111,238,.48);text-decoration:underline dashed rgba(51,111,238,.48);text-underline-offset:.2em;text-decoration-thickness:.7px}.t-icon[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;width:var(--tui-link-icon-size, 1.5rem);height:var(--tui-link-icon-size, 1.5rem);margin-top:-.125rem}.t-icon_left[_ngcontent-%COMP%]{margin-right:.25rem}.t-icon_right[_ngcontent-%COMP%]{margin-left:.25rem}._icon-rotated[_nghost-%COMP%]   .t-icon[_ngcontent-%COMP%]{transform:rotate(180deg)}"],
  changeDetection: 0
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TuiLinkComponent, [{
    type: Component,
    args: [{
      selector: 'a[tuiLink], button[tuiLink]',
      templateUrl: './link.template.html',
      styleUrls: ['./link.style.less'],
      changeDetection: ChangeDetectionStrategy.OnPush,
      providers: [tuiAsFocusableItemAccessor(TuiLinkComponent), TuiFocusVisibleService, TuiDestroyService, MODE_PROVIDER],
      host: {
        '($.data-mode.attr)': 'mode$'
      },
      exportAs: 'tuiLink'
    }]
  }], function () {
    return [{
      type: i0.ElementRef,
      decorators: [{
        type: Inject,
        args: [ElementRef]
      }]
    }, {
      type: i3.Observable,
      decorators: [{
        type: Inject,
        args: [TUI_MODE]
      }]
    }, {
      type: i4.TuiFocusVisibleService,
      decorators: [{
        type: Inject,
        args: [TuiFocusVisibleService]
      }]
    }];
  }, {
    pseudo: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class._pseudo']
    }],
    icon: [{
      type: Input
    }],
    iconAlign: [{
      type: Input
    }],
    iconRotated: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['class._icon-rotated']
    }],
    mode: [{
      type: Input
    }, {
      type: HostBinding,
      args: ['attr.data-host-mode']
    }],
    focusVisible: [{
      type: HostBinding,
      args: ['class._focus-visible']
    }]
  });
})();
class TuiLinkModule {}
TuiLinkModule.ɵfac = function TuiLinkModule_Factory(t) {
  return new (t || TuiLinkModule)();
};
TuiLinkModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: TuiLinkModule
});
TuiLinkModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  imports: [[CommonModule, TuiSvgModule]]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TuiLinkModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, TuiSvgModule],
      declarations: [TuiLinkComponent],
      exports: [TuiLinkComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiLinkComponent, TuiLinkModule };
